import React from 'react';
import { SectionAbout, AboutImg, AboutText } from '../styles';

const About = () => {
    return (
        <SectionAbout id="about">
            <AboutText>
                <h3>About Me</h3>
                <p>Hi, I'm Ezequiel, a backend and frontend developer. I enjoy creating things on the internet as web applications. My goal is to create applications that offer the best experiences and that help us to innovate in the present and in the future. Right now I am working at Coordinadora Mercantil S.A. with an excellent team, developing internal and external applications. Here are some technologies that I have worked with at some point.</p>
                <ul>
                    <div>
                        <li>HTML5 & CSS3</li>
                        <li>JavaScript(ES6+)</li>
                        <li>TypeScript</li>
                        <li>React Hooks</li>
                        <li>React Redux v7</li>
                        <li>Gatsby</li>
                        <li>GraphQL</li>
                        <li>Next.js</li>
                    </div>
                    <div>
                        <li>Node.js</li>
                        <li>Express.js</li>
                        <li>Firebase</li>
                        <li>MongoDB</li>
                        <li>PostgreSQL</li>
                        <li>MySQL</li>
                        <li>API's</li>
                        <li>Git</li>
                    </div>
                </ul>
            </AboutText>
            <AboutImg>
                <img src="./img/me.jpg" alt="Ezequiel Luján"/>
            </AboutImg>
        </SectionAbout>
    );
}

export default About;